// Hidden Masonry nodes (the `selectionError` reveal target and the plan-count
// hidden field) still occupy a layout slot: the SDK's verticalLayout wraps every
// child in a StackItem that only collapses when the child is `:empty` or
// `.visually-hidden`. A `.hidden-masonry-subtree` child (display: none) — or the
// hidden plan-count field, whose `.visually-hidden` sits below the StackItem's
// direct child so the SDK's `:has(> .visually-hidden)` escape hatch doesn't
// reach it — leaves a zero-height wrapper that still earns a phantom stack gap.
// Hide the wrappers themselves; the hidden class is state-driven, so a revealed
// node's wrapper reappears. Shared by the gate and the Switch Accounts chrome so
// the two can't drift. Proper fix belongs in the SDK's StackItem escape hatch.
export const hiddenMasonryNodeStyles = {
  '& div:has(> .hidden-masonry-subtree)': {
    display: 'none',
  },
  '& div:has(> [data-testid$="planCountHiddenField"])': {
    display: 'none',
  },
  '& [data-testid$="planCountHiddenField"]': {
    display: 'none',
  },
};
